module.exports = __webpack_public_path__ + "f26b726b6d65585434e82bb061937a27.png";